import { render, staticRenderFns } from "./sole-good.vue?vue&type=template&id=22338999"
import script from "./sole-good.vue?vue&type=script&lang=js"
export * from "./sole-good.vue?vue&type=script&lang=js"
import style0 from "./sole-good.vue?vue&type=style&index=0&id=22338999&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports